(function (factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js', './Hadaya_client_web-shared.js', './compose-multiplatform-core-compose-ui-ui.js', './androidx-compose-runtime-runtime.js', './projects-core-koin-core.js', './kotlinx-coroutines-core.js', './ktor-ktor-client-core.js', './coil-root-coil-network-ktor3.js', './cryptography-kotlin-cryptography-provider-webcrypto.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'), require('./Hadaya_client_web-shared.js'), require('./compose-multiplatform-core-compose-ui-ui.js'), require('./androidx-compose-runtime-runtime.js'), require('./projects-core-koin-core.js'), require('./kotlinx-coroutines-core.js'), require('./ktor-ktor-client-core.js'), require('./coil-root-coil-network-ktor3.js'), require('./cryptography-kotlin-cryptography-provider-webcrypto.js'));
  else {
    if (typeof globalThis['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'Hadaya_client_web:webApp'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'Hadaya_client_web:webApp'.");
    }
    if (typeof globalThis['Hadaya_client_web-shared'] === 'undefined') {
      throw new Error("Error loading module 'Hadaya_client_web:webApp'. Its dependency 'Hadaya_client_web-shared' was not found. Please, check whether 'Hadaya_client_web-shared' is loaded prior to 'Hadaya_client_web:webApp'.");
    }
    if (typeof globalThis['compose-multiplatform-core-compose-ui-ui'] === 'undefined') {
      throw new Error("Error loading module 'Hadaya_client_web:webApp'. Its dependency 'compose-multiplatform-core-compose-ui-ui' was not found. Please, check whether 'compose-multiplatform-core-compose-ui-ui' is loaded prior to 'Hadaya_client_web:webApp'.");
    }
    if (typeof globalThis['androidx-compose-runtime-runtime'] === 'undefined') {
      throw new Error("Error loading module 'Hadaya_client_web:webApp'. Its dependency 'androidx-compose-runtime-runtime' was not found. Please, check whether 'androidx-compose-runtime-runtime' is loaded prior to 'Hadaya_client_web:webApp'.");
    }
    if (typeof globalThis['projects-core-koin-core'] === 'undefined') {
      throw new Error("Error loading module 'Hadaya_client_web:webApp'. Its dependency 'projects-core-koin-core' was not found. Please, check whether 'projects-core-koin-core' is loaded prior to 'Hadaya_client_web:webApp'.");
    }
    if (typeof globalThis['kotlinx-coroutines-core'] === 'undefined') {
      throw new Error("Error loading module 'Hadaya_client_web:webApp'. Its dependency 'kotlinx-coroutines-core' was not found. Please, check whether 'kotlinx-coroutines-core' is loaded prior to 'Hadaya_client_web:webApp'.");
    }
    if (typeof globalThis['ktor-ktor-client-core'] === 'undefined') {
      throw new Error("Error loading module 'Hadaya_client_web:webApp'. Its dependency 'ktor-ktor-client-core' was not found. Please, check whether 'ktor-ktor-client-core' is loaded prior to 'Hadaya_client_web:webApp'.");
    }
    if (typeof globalThis['coil-root-coil-network-ktor3'] === 'undefined') {
      throw new Error("Error loading module 'Hadaya_client_web:webApp'. Its dependency 'coil-root-coil-network-ktor3' was not found. Please, check whether 'coil-root-coil-network-ktor3' is loaded prior to 'Hadaya_client_web:webApp'.");
    }
    if (typeof globalThis['cryptography-kotlin-cryptography-provider-webcrypto'] === 'undefined') {
      throw new Error("Error loading module 'Hadaya_client_web:webApp'. Its dependency 'cryptography-kotlin-cryptography-provider-webcrypto' was not found. Please, check whether 'cryptography-kotlin-cryptography-provider-webcrypto' is loaded prior to 'Hadaya_client_web:webApp'.");
    }
    globalThis['Hadaya_client_web:webApp'] = factory(typeof globalThis['Hadaya_client_web:webApp'] === 'undefined' ? {} : globalThis['Hadaya_client_web:webApp'], globalThis['kotlin-kotlin-stdlib'], globalThis['Hadaya_client_web-shared'], globalThis['compose-multiplatform-core-compose-ui-ui'], globalThis['androidx-compose-runtime-runtime'], globalThis['projects-core-koin-core'], globalThis['kotlinx-coroutines-core'], globalThis['ktor-ktor-client-core'], globalThis['coil-root-coil-network-ktor3'], globalThis['cryptography-kotlin-cryptography-provider-webcrypto']);
  }
}(function (_, kotlin_kotlin, kotlin_Hadaya_client_web_shared, kotlin_org_jetbrains_compose_ui_ui, kotlin_androidx_compose_runtime_runtime, kotlin_io_insert_koin_koin_core, kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core, kotlin_io_ktor_ktor_client_core, kotlin_io_coil_kt_coil3_coil_network_ktor3, kotlin_dev_whyoleg_cryptography_cryptography_provider_webcrypto) {
  'use strict';
  //region block: imports
  var VOID = kotlin_kotlin.$_$.d;
  var Unit_instance = kotlin_kotlin.$_$.o3;
  var initKoin = kotlin_Hadaya_client_web_shared.$_$.a;
  var ComposeViewport = kotlin_org_jetbrains_compose_ui_ui.$_$.ia;
  var constructCallableReference = kotlin_kotlin.$_$.of;
  var sourceInformation = kotlin_androidx_compose_runtime_runtime.$_$.k2;
  var traceEventStart = kotlin_androidx_compose_runtime_runtime.$_$.p2;
  var isTraceInProgress = kotlin_androidx_compose_runtime_runtime.$_$.s1;
  var KoinPlatform_instance = kotlin_io_insert_koin_koin_core.$_$.c;
  var AppViewModel = kotlin_Hadaya_client_web_shared.$_$.b;
  var getKClass = kotlin_kotlin.$_$.si;
  var IAnalyticsHelper = kotlin_Hadaya_client_web_shared.$_$.p;
  var sourceInformationMarkerStart = kotlin_androidx_compose_runtime_runtime.$_$.j2;
  var Shopping_getInstance = kotlin_Hadaya_client_web_shared.$_$.z;
  var mutableStateListOf = kotlin_androidx_compose_runtime_runtime.$_$.y1;
  var Companion_getInstance = kotlin_androidx_compose_runtime_runtime.$_$.w2;
  var sourceInformationMarkerEnd = kotlin_androidx_compose_runtime_runtime.$_$.i2;
  var mutableStateOf = kotlin_androidx_compose_runtime_runtime.$_$.b2;
  var LaunchedEffect = kotlin_androidx_compose_runtime_runtime.$_$.r;
  var DisposableEffect = kotlin_androidx_compose_runtime_runtime.$_$.q;
  var lastOrNull = kotlin_kotlin.$_$.ka;
  var App = kotlin_Hadaya_client_web_shared.$_$.o;
  var traceEventEnd = kotlin_androidx_compose_runtime_runtime.$_$.o2;
  var KMutableProperty0 = kotlin_kotlin.$_$.vi;
  var getLocalDelegateReference = kotlin_kotlin.$_$.wf;
  var CoroutineImpl = kotlin_kotlin.$_$.xd;
  var protoOf = kotlin_kotlin.$_$.eh;
  var THROW_CCE = kotlin_kotlin.$_$.sn;
  var CoroutineScope = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.y2;
  var isInterface = kotlin_kotlin.$_$.rg;
  var substringAfter = kotlin_kotlin.$_$.jl;
  var substringBefore = kotlin_kotlin.$_$.ll;
  var replace = kotlin_kotlin.$_$.xk;
  var contains = kotlin_kotlin.$_$.nj;
  var Auth = kotlin_Hadaya_client_web_shared.$_$.c;
  var DeleteAccountStandalone = kotlin_Hadaya_client_web_shared.$_$.j;
  var split = kotlin_kotlin.$_$.cl;
  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.a4;
  var charSequenceLength = kotlin_kotlin.$_$.lf;
  var getOrNull = kotlin_kotlin.$_$.t9;
  var toLongOrNull = kotlin_kotlin.$_$.am;
  var Profile_getInstance = kotlin_Hadaya_client_web_shared.$_$.x;
  var equals = kotlin_kotlin.$_$.sf;
  var Cart_getInstance = kotlin_Hadaya_client_web_shared.$_$.r;
  var OrderHistory_getInstance = kotlin_Hadaya_client_web_shared.$_$.w;
  var Coupons_getInstance = kotlin_Hadaya_client_web_shared.$_$.s;
  var Favorites_getInstance = kotlin_Hadaya_client_web_shared.$_$.u;
  var Friends_getInstance = kotlin_Hadaya_client_web_shared.$_$.v;
  var StockReminders_getInstance = kotlin_Hadaya_client_web_shared.$_$.a1;
  var AccountManagement_getInstance = kotlin_Hadaya_client_web_shared.$_$.q;
  var initMetadataForLambda = kotlin_kotlin.$_$.hg;
  var initMetadataForClass = kotlin_kotlin.$_$.cg;
  var firstOrNull = kotlin_kotlin.$_$.k9;
  var CustomMagicMugDetails = kotlin_Hadaya_client_web_shared.$_$.h;
  var CustomMugDetails = kotlin_Hadaya_client_web_shared.$_$.i;
  var BeadsProductDetails = kotlin_Hadaya_client_web_shared.$_$.d;
  var ProductDetails = kotlin_Hadaya_client_web_shared.$_$.n;
  var toString = kotlin_kotlin.$_$.hp;
  var PastOrderDetails = kotlin_Hadaya_client_web_shared.$_$.m;
  var OrderDetails = kotlin_Hadaya_client_web_shared.$_$.l;
  var Model3D = kotlin_Hadaya_client_web_shared.$_$.k;
  var CartMagicMugProductDetails = kotlin_Hadaya_client_web_shared.$_$.e;
  var CartMugProductDetails = kotlin_Hadaya_client_web_shared.$_$.f;
  var CartNormalProductDetails = kotlin_Hadaya_client_web_shared.$_$.g;
  var ResetPasswordSuccess_getInstance = kotlin_Hadaya_client_web_shared.$_$.y;
  var DeleteAccountSuccess_getInstance = kotlin_Hadaya_client_web_shared.$_$.t;
  var composableLambdaInstance = kotlin_androidx_compose_runtime_runtime.$_$.b;
  var initMetadataForObject = kotlin_kotlin.$_$.ig;
  //endregion
  //region block: pre-declaration
  initMetadataForLambda(ComposableSingletons$MainKt$lambda$207007617$lambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(ComposableSingletons$MainKt$lambda$207007617$1$1$$inlined$cache$2$2);
  initMetadataForLambda(ComposableSingletons$MainKt$lambda$207007617$lambda$slambda_1, CoroutineImpl, VOID, [1]);
  initMetadataForObject(ComposableSingletons$MainKt, 'ComposableSingletons$MainKt');
  //endregion
  var hadaya_client_web_webapp_generated_resources_Res_drawable$stable;
  var hadaya_client_web_webapp_generated_resources_Res_string$stable;
  var hadaya_client_web_webapp_generated_resources_Res_array$stable;
  var hadaya_client_web_webapp_generated_resources_Res_plurals$stable;
  var hadaya_client_web_webapp_generated_resources_Res_font$stable;
  var hadaya_client_web_webapp_generated_resources_Res$stable;
  function updateMetadata(title, description, imageUrl) {
    description = description === VOID ? 'Hadaya' : description;
    imageUrl = imageUrl === VOID ? null : imageUrl;
    window.document.title = title;
    var tmp0_safe_receiver = window.document.querySelector("meta[name='description']");
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.setAttribute('content', description);
    }
    var tmp1_safe_receiver = window.document.querySelector("meta[property='og:title']");
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.setAttribute('content', title);
    }
    var tmp2_safe_receiver = window.document.querySelector("meta[property='og:description']");
    if (tmp2_safe_receiver == null)
      null;
    else {
      tmp2_safe_receiver.setAttribute('content', description);
    }
    if (imageUrl == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      var tmp0_safe_receiver_0 = window.document.querySelector("meta[property='og:image']");
      var tmp;
      if (tmp0_safe_receiver_0 == null) {
        tmp = null;
      } else {
        tmp0_safe_receiver_0.setAttribute('content', imageUrl);
        tmp = Unit_instance;
      }
    }
    var tmp4_safe_receiver = window.document.querySelector("meta[property='twitter:title']");
    if (tmp4_safe_receiver == null)
      null;
    else {
      tmp4_safe_receiver.setAttribute('content', title);
    }
    var tmp5_safe_receiver = window.document.querySelector("meta[property='twitter:description']");
    if (tmp5_safe_receiver == null)
      null;
    else {
      tmp5_safe_receiver.setAttribute('content', description);
    }
    if (imageUrl == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      var tmp0_safe_receiver_1 = window.document.querySelector("meta[property='twitter:image']");
      var tmp_0;
      if (tmp0_safe_receiver_1 == null) {
        tmp_0 = null;
      } else {
        tmp0_safe_receiver_1.setAttribute('content', imageUrl);
        tmp_0 = Unit_instance;
      }
    }
  }
  function main() {
    initKoin();
    ComposeViewport('compose-target', VOID, ComposableSingletons$MainKt_getInstance().k14x_1);
  }
  function ComposableLambda$invoke$ref(p0) {
    return constructCallableReference(function (p0_0, p1) {
      p0.t50(p0_0, p1);
      return Unit_instance;
    }, 2, 0, 17, VOID, [p0]);
  }
  function ComposableSingletons$MainKt$lambda$207007617$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C39@1668L56,40@1758L40,41@1830L40,43@1901L2856,43@1880L2877,85@4790L2018,85@4767L2041,131@6918L4330,131@6888L4360,207@11258L100:main.kt#g9gxws');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(207007617, $changed, -1, 'client.fstech.hadaya.web.ComposableSingletons$MainKt.lambda$207007617.<anonymous> (main.kt:37)');
      }
      // Inline function 'org.koin.core.Koin.get' call
      // Inline function 'org.koin.core.scope.Scope.get' call
      var appViewModel = KoinPlatform_instance.vs6().es2_1.ns2_1.ss6(getKClass(AppViewModel), null, null);
      // Inline function 'org.koin.core.Koin.get' call
      // Inline function 'org.koin.core.scope.Scope.get' call
      var analytics = KoinPlatform_instance.vs6().es2_1.ns2_1.ss6(getKClass(IAnalyticsHelper), null, null);
      sourceInformationMarkerStart($composer_0, 1365829561, 'CC(remember):main.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      // Inline function 'kotlin.let' call
      var it = $composer_0.i31();
      var tmp;
      if (false || it === Companion_getInstance().f30_1) {
        var value = mutableStateListOf([Shopping_getInstance()]);
        $composer_0.j31(value);
        tmp = value;
      } else {
        tmp = it;
      }
      var tmp0_group = tmp;
      sourceInformationMarkerEnd($composer_0);
      var backStack = tmp0_group;
      sourceInformationMarkerStart($composer_0, 1365832425, 'CC(remember):main.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      // Inline function 'kotlin.let' call
      var it_0 = $composer_0.i31();
      var tmp_0;
      if (false || it_0 === Companion_getInstance().f30_1) {
        var value_0 = mutableStateOf(null);
        $composer_0.j31(value_0);
        tmp_0 = value_0;
      } else {
        tmp_0 = it_0;
      }
      var tmp1_group = tmp_0;
      sourceInformationMarkerEnd($composer_0);
      var deepLinkProductId$delegate = tmp1_group;
      sourceInformationMarkerStart($composer_0, 1365834729, 'CC(remember):main.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      // Inline function 'kotlin.let' call
      var it_1 = $composer_0.i31();
      var tmp_1;
      if (false || it_1 === Companion_getInstance().f30_1) {
        var value_1 = mutableStateOf(null);
        $composer_0.j31(value_1);
        tmp_1 = value_1;
      } else {
        tmp_1 = it_1;
      }
      var tmp2_group = tmp_1;
      sourceInformationMarkerEnd($composer_0);
      var deepLinkOrderId$delegate = tmp2_group;
      sourceInformationMarkerStart($composer_0, 1365839817, 'CC(remember):main.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      // Inline function 'kotlin.let' call
      var it_2 = $composer_0.i31();
      var tmp_2;
      if (false || it_2 === Companion_getInstance().f30_1) {
        var value_2 = ComposableSingletons$MainKt$lambda$207007617$lambda$slambda_0(backStack, deepLinkProductId$delegate, deepLinkOrderId$delegate, null);
        $composer_0.j31(value_2);
        tmp_2 = value_2;
      } else {
        tmp_2 = it_2;
      }
      var tmp3_group = tmp_2;
      sourceInformationMarkerEnd($composer_0);
      LaunchedEffect(Unit_instance, tmp3_group, $composer_0, 6);
      sourceInformationMarkerStart($composer_0, 1365931427, 'CC(remember):main.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      // Inline function 'kotlin.let' call
      var it_3 = $composer_0.i31();
      var tmp_3;
      if (false || it_3 === Companion_getInstance().f30_1) {
        var value_3 = ComposableSingletons$MainKt$lambda$207007617$lambda$lambda(backStack);
        $composer_0.j31(value_3);
        tmp_3 = value_3;
      } else {
        tmp_3 = it_3;
      }
      var tmp4_group = tmp_3;
      sourceInformationMarkerEnd($composer_0);
      DisposableEffect(Unit_instance, tmp4_group, $composer_0, 54);
      var tmp0_elvis_lhs = lastOrNull(backStack);
      var currentScreen = tmp0_elvis_lhs == null ? Shopping_getInstance() : tmp0_elvis_lhs;
      sourceInformationMarkerStart($composer_0, 1366001835, 'CC(remember):main.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = !!(!!($composer_0.q31(appViewModel) | $composer_0.q31(currentScreen)) | $composer_0.q31(analytics));
      // Inline function 'kotlin.let' call
      var it_4 = $composer_0.i31();
      var tmp_4;
      if (invalid || it_4 === Companion_getInstance().f30_1) {
        var value_4 = ComposableSingletons$MainKt$lambda$207007617$lambda$slambda_2(appViewModel, currentScreen, analytics, null);
        $composer_0.j31(value_4);
        tmp_4 = value_4;
      } else {
        tmp_4 = it_4;
      }
      var tmp5_group = tmp_4;
      sourceInformationMarkerEnd($composer_0);
      LaunchedEffect(currentScreen, tmp5_group, $composer_0, 0);
      var tmp1_deepLinkProductId = invoke$lambda(deepLinkProductId$delegate);
      var tmp2_deepLinkOrderId = invoke$lambda_1(deepLinkOrderId$delegate);
      App(null, null, tmp1_deepLinkProductId, tmp2_deepLinkOrderId, backStack, $composer_0, 24576, 3);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function invoke$lambda($deepLinkProductId$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('deepLinkProductId', KMutableProperty0, true);
    return $deepLinkProductId$delegate.u1();
  }
  function invoke$lambda_0($deepLinkProductId$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('deepLinkProductId', KMutableProperty0, true);
    $deepLinkProductId$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function invoke$lambda_1($deepLinkOrderId$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('deepLinkOrderId', KMutableProperty0, true);
    return $deepLinkOrderId$delegate.u1();
  }
  function invoke$lambda_2($deepLinkOrderId$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('deepLinkOrderId', KMutableProperty0, true);
    $deepLinkOrderId$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function ComposableSingletons$MainKt$lambda$207007617$lambda$slambda($backStack, $deepLinkProductId$delegate, $deepLinkOrderId$delegate, resultContinuation) {
    this.t14x_1 = $backStack;
    this.u14x_1 = $deepLinkProductId$delegate;
    this.v14x_1 = $deepLinkOrderId$delegate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ComposableSingletons$MainKt$lambda$207007617$lambda$slambda).p24 = function ($this$LaunchedEffect, $completion) {
    var tmp = this.q24($this$LaunchedEffect, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ComposableSingletons$MainKt$lambda$207007617$lambda$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ComposableSingletons$MainKt$lambda$207007617$lambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          var path = window.location.pathname;
          var fullUrl = window.location.href;
          if (contains(fullUrl, 'access_token=')) {
            var token = substringBefore(substringBefore(substringAfter(fullUrl, 'access_token='), '&'), '#');
            var tmp_0;
            if (contains(fullUrl, 'email=')) {
              tmp_0 = replace(substringBefore(substringBefore(substringAfter(fullUrl, 'email='), '&'), '#'), '%40', '@');
            } else {
              tmp_0 = null;
            }
            var email = tmp_0;
            if (contains(fullUrl, 'action=delete')) {
              var tmp_1 = lastOrNull(this.t14x_1);
              if (!(tmp_1 instanceof DeleteAccountStandalone)) {
                this.t14x_1.zz(new DeleteAccountStandalone(token, email));
              }
            } else if (contains(fullUrl, 'type=recovery')) {
              var tmp_2 = lastOrNull(this.t14x_1);
              if (!(tmp_2 instanceof Auth)) {
                this.t14x_1.zz(new Auth('reset-password', fullUrl));
              }
            }
          }
          var tmp0 = split(path, ['/']);
          var destination = ArrayList_init_$Create$();
          var _iterator__ex2g4s = tmp0.t();
          while (_iterator__ex2g4s.u()) {
            var element = _iterator__ex2g4s.v();
            if (charSequenceLength(element) > 0) {
              destination.j1(element);
            }
          }
          var segments = destination;
          if (!segments.r()) {
            switch (segments.l1(0)) {
              case 'product':
                var tmp1_safe_receiver = getOrNull(segments, 1);
                var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : toLongOrNull(tmp1_safe_receiver);
                if (tmp2_safe_receiver == null)
                  null;
                else {
                  invoke$lambda_0(this.u14x_1, tmp2_safe_receiver);
                }

                break;
              case 'order':
                var tmp3_safe_receiver = getOrNull(segments, 1);
                var tmp4_safe_receiver = tmp3_safe_receiver == null ? null : toLongOrNull(tmp3_safe_receiver);
                if (tmp4_safe_receiver == null)
                  null;
                else {
                  invoke$lambda_2(this.v14x_1, tmp4_safe_receiver);
                }

                break;
              case 'profile':
                if (!equals(lastOrNull(this.t14x_1), Profile_getInstance())) {
                  this.t14x_1.zz(Profile_getInstance());
                }

                break;
              case 'cart':
                if (!equals(lastOrNull(this.t14x_1), Cart_getInstance())) {
                  this.t14x_1.zz(Cart_getInstance());
                }

                break;
              case 'orders':
                if (!equals(lastOrNull(this.t14x_1), OrderHistory_getInstance())) {
                  this.t14x_1.zz(OrderHistory_getInstance());
                }

                break;
              case 'coupons':
                if (!equals(lastOrNull(this.t14x_1), Coupons_getInstance())) {
                  this.t14x_1.zz(Coupons_getInstance());
                }

                break;
              case 'login':
              case 'authentication':
                var tmp_3 = lastOrNull(this.t14x_1);
                if (!(tmp_3 instanceof Auth)) {
                  this.t14x_1.zz(new Auth('login'));
                }

                break;
              case 'signup':
                var tmp_4 = lastOrNull(this.t14x_1);
                if (!(tmp_4 instanceof Auth)) {
                  this.t14x_1.zz(new Auth('signup'));
                }

                break;
              case 'forget-password':
              case 'forgot-password':
                var tmp_5 = lastOrNull(this.t14x_1);
                if (!(tmp_5 instanceof Auth)) {
                  this.t14x_1.zz(new Auth('forgot-password'));
                }

                break;
              case 'favorites':
                if (!equals(lastOrNull(this.t14x_1), Favorites_getInstance())) {
                  this.t14x_1.zz(Favorites_getInstance());
                }

                break;
              case 'friends':
                if (!equals(lastOrNull(this.t14x_1), Friends_getInstance())) {
                  this.t14x_1.zz(Friends_getInstance());
                }

                break;
              case 'reminders':
                if (!equals(lastOrNull(this.t14x_1), StockReminders_getInstance())) {
                  this.t14x_1.zz(StockReminders_getInstance());
                }

                break;
              case 'accountmanagement':
                if (!equals(lastOrNull(this.t14x_1), AccountManagement_getInstance())) {
                  this.t14x_1.zz(AccountManagement_getInstance());
                }

                break;
              case 'reset-password':
                var tmp_6 = lastOrNull(this.t14x_1);
                if (!(tmp_6 instanceof Auth)) {
                  this.t14x_1.zz(new Auth('reset-password'));
                }

                break;
            }
          }
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(ComposableSingletons$MainKt$lambda$207007617$lambda$slambda).q24 = function ($this$LaunchedEffect, completion) {
    var i = new ComposableSingletons$MainKt$lambda$207007617$lambda$slambda(this.t14x_1, this.u14x_1, this.v14x_1, completion);
    i.w14x_1 = $this$LaunchedEffect;
    return i;
  };
  function ComposableSingletons$MainKt$lambda$207007617$lambda$slambda_0($backStack, $deepLinkProductId$delegate, $deepLinkOrderId$delegate, resultContinuation) {
    var i = new ComposableSingletons$MainKt$lambda$207007617$lambda$slambda($backStack, $deepLinkProductId$delegate, $deepLinkOrderId$delegate, resultContinuation);
    return constructCallableReference(function ($this$LaunchedEffect, $completion) {
      return i.p24($this$LaunchedEffect, $completion);
    }, 1);
  }
  function ComposableSingletons$MainKt$lambda$207007617$lambda$lambda$lambda($backStack) {
    return function (_unused_var__etf5q3) {
      var path = window.location.pathname;
      // Inline function 'kotlin.collections.filter' call
      var tmp0 = split(path, ['/']);
      // Inline function 'kotlin.collections.filterTo' call
      var destination = ArrayList_init_$Create$();
      var _iterator__ex2g4s = tmp0.t();
      while (_iterator__ex2g4s.u()) {
        var element = _iterator__ex2g4s.v();
        // Inline function 'kotlin.text.isNotEmpty' call
        if (charSequenceLength(element) > 0) {
          destination.j1(element);
        }
      }
      var segments = destination;
      var tmp;
      if (segments.r()) {
        var tmp_0;
        if ($backStack.n1() > 1) {
          $backStack.c3();
          $backStack.zz(Shopping_getInstance());
          tmp_0 = Unit_instance;
        }
        tmp = tmp_0;
      } else {
        var targetScreen;
        switch (segments.l1(0)) {
          case 'profile':
            targetScreen = Profile_getInstance();
            break;
          case 'cart':
            targetScreen = Cart_getInstance();
            break;
          case 'orders':
            targetScreen = OrderHistory_getInstance();
            break;
          case 'coupons':
            targetScreen = Coupons_getInstance();
            break;
          case 'login':
          case 'authentication':
            targetScreen = new Auth('login');
            break;
          case 'signup':
            targetScreen = new Auth('signup');
            break;
          case 'forget-password':
          case 'forgot-password':
            targetScreen = new Auth('forgot-password');
            break;
          case 'favorites':
            targetScreen = Favorites_getInstance();
            break;
          case 'friends':
            targetScreen = Friends_getInstance();
            break;
          case 'reminders':
            targetScreen = StockReminders_getInstance();
            break;
          case 'accountmanagement':
            targetScreen = AccountManagement_getInstance();
            break;
          case 'reset-password':
            targetScreen = new Auth('reset-password');
            break;
          default:
            targetScreen = null;
            break;
        }
        var tmp_1;
        if (!(targetScreen == null) && !equals(lastOrNull($backStack), targetScreen)) {
          var index = $backStack.yz(targetScreen);
          if (!(index === -1)) {
            while ($backStack.n1() > (index + 1 | 0)) {
              $backStack.h3($backStack.n1() - 1 | 0);
            }
          } else {
            $backStack.zz(targetScreen);
          }
          tmp_1 = Unit_instance;
        }
        tmp = tmp_1;
      }
      return Unit_instance;
    };
  }
  function ComposableSingletons$MainKt$lambda$207007617$1$1$$inlined$cache$2$2($onPopState) {
    this.x14x_1 = $onPopState;
  }
  protoOf(ComposableSingletons$MainKt$lambda$207007617$1$1$$inlined$cache$2$2).s1d = function () {
    window.removeEventListener('popstate', this.x14x_1);
  };
  function ComposableSingletons$MainKt$lambda$207007617$lambda$lambda($backStack) {
    return function ($this$DisposableEffect) {
      var onPopState = ComposableSingletons$MainKt$lambda$207007617$lambda$lambda$lambda($backStack);
      window.addEventListener('popstate', onPopState);
      // Inline function 'androidx.compose.runtime.DisposableEffectScope.onDispose' call
      return new ComposableSingletons$MainKt$lambda$207007617$1$1$$inlined$cache$2$2(onPopState);
    };
  }
  function ComposableSingletons$MainKt$lambda$207007617$lambda$slambda_1($appViewModel, $currentScreen, $analytics, resultContinuation) {
    this.g14y_1 = $appViewModel;
    this.h14y_1 = $currentScreen;
    this.i14y_1 = $analytics;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ComposableSingletons$MainKt$lambda$207007617$lambda$slambda_1).p24 = function ($this$LaunchedEffect, $completion) {
    var tmp = this.q24($this$LaunchedEffect, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ComposableSingletons$MainKt$lambda$207007617$lambda$slambda_1).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ComposableSingletons$MainKt$lambda$207007617$lambda$slambda_1).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          var isArabic = this.g14y_1.fyj_1.u1() === 'ar';
          var title = isArabic ? '\u0647\u062F\u0627\u064A\u0627' : 'Hadaya';
          var description = 'Hadaya';
          var imageUrl = null;
          var tmp0_subject = this.h14y_1;
          if (tmp0_subject instanceof ProductDetails) {
            var tmp1_elvis_lhs = isArabic ? this.h14y_1.u108_1.pzt_1 : this.h14y_1.u108_1.ozt_1;
            title = tmp1_elvis_lhs == null ? title : tmp1_elvis_lhs;
            var tmp2_elvis_lhs = isArabic ? this.h14y_1.u108_1.rzt_1 : this.h14y_1.u108_1.qzt_1;
            description = tmp2_elvis_lhs == null ? description : tmp2_elvis_lhs;
            var tmp3_safe_receiver = this.h14y_1.u108_1.xzt_1;
            imageUrl = tmp3_safe_receiver == null ? null : firstOrNull(tmp3_safe_receiver);
          } else {
            if (tmp0_subject instanceof BeadsProductDetails) {
              var tmp4_elvis_lhs = isArabic ? this.h14y_1.i109_1.pzt_1 : this.h14y_1.i109_1.ozt_1;
              title = tmp4_elvis_lhs == null ? title : tmp4_elvis_lhs;
              var tmp5_elvis_lhs = isArabic ? this.h14y_1.i109_1.rzt_1 : this.h14y_1.i109_1.qzt_1;
              description = tmp5_elvis_lhs == null ? description : tmp5_elvis_lhs;
              var tmp6_safe_receiver = this.h14y_1.i109_1.xzt_1;
              imageUrl = tmp6_safe_receiver == null ? null : firstOrNull(tmp6_safe_receiver);
            } else {
              if (tmp0_subject instanceof CustomMugDetails) {
                var tmp7_elvis_lhs = isArabic ? this.h14y_1.x109_1.pzt_1 : this.h14y_1.x109_1.ozt_1;
                title = tmp7_elvis_lhs == null ? title : tmp7_elvis_lhs;
                var tmp8_elvis_lhs = isArabic ? this.h14y_1.x109_1.rzt_1 : this.h14y_1.x109_1.qzt_1;
                description = tmp8_elvis_lhs == null ? description : tmp8_elvis_lhs;
                var tmp9_safe_receiver = this.h14y_1.x109_1.xzt_1;
                imageUrl = tmp9_safe_receiver == null ? null : firstOrNull(tmp9_safe_receiver);
              } else {
                if (tmp0_subject instanceof CustomMagicMugDetails) {
                  var tmp10_elvis_lhs = isArabic ? this.h14y_1.l10a_1.pzt_1 : this.h14y_1.l10a_1.ozt_1;
                  title = tmp10_elvis_lhs == null ? title : tmp10_elvis_lhs;
                  var tmp11_elvis_lhs = isArabic ? this.h14y_1.l10a_1.rzt_1 : this.h14y_1.l10a_1.qzt_1;
                  description = tmp11_elvis_lhs == null ? description : tmp11_elvis_lhs;
                  var tmp12_safe_receiver = this.h14y_1.l10a_1.xzt_1;
                  imageUrl = tmp12_safe_receiver == null ? null : firstOrNull(tmp12_safe_receiver);
                }
              }
            }
          }
          updateMetadata(title, description, imageUrl);
          var tmp13_subject = this.h14y_1;
          var tmp_0;
          if (equals(tmp13_subject, Shopping_getInstance())) {
            tmp_0 = '/';
          } else {
            if (equals(tmp13_subject, Profile_getInstance())) {
              tmp_0 = '/profile';
            } else {
              if (equals(tmp13_subject, Cart_getInstance())) {
                tmp_0 = '/cart';
              } else {
                if (equals(tmp13_subject, OrderHistory_getInstance())) {
                  tmp_0 = '/orders';
                } else {
                  if (equals(tmp13_subject, Coupons_getInstance())) {
                    tmp_0 = '/coupons';
                  } else {
                    if (equals(tmp13_subject, Favorites_getInstance())) {
                      tmp_0 = '/favorites';
                    } else {
                      if (equals(tmp13_subject, Friends_getInstance())) {
                        tmp_0 = '/friends';
                      } else {
                        if (equals(tmp13_subject, StockReminders_getInstance())) {
                          tmp_0 = '/reminders';
                        } else {
                          if (equals(tmp13_subject, AccountManagement_getInstance())) {
                            tmp_0 = '/accountmanagement';
                          } else {
                            if (equals(tmp13_subject, DeleteAccountSuccess_getInstance())) {
                              tmp_0 = '/accountmanagement/success';
                            } else {
                              if (equals(tmp13_subject, ResetPasswordSuccess_getInstance())) {
                                tmp_0 = '/accountmanagement/reset-success';
                              } else {
                                if (tmp13_subject instanceof DeleteAccountStandalone) {
                                  tmp_0 = '/accountmanagement/delete';
                                } else {
                                  if (tmp13_subject instanceof Auth) {
                                    switch (this.h14y_1.f10b_1) {
                                      case 'signup':
                                        tmp_0 = '/signup';
                                        break;
                                      case 'forget-password':
                                      case 'forgot-password':
                                        tmp_0 = '/forgot-password';
                                        break;
                                      case 'reset-password':
                                        tmp_0 = '/reset-password';
                                        break;
                                      default:
                                        tmp_0 = '/login';
                                        break;
                                    }
                                  } else {
                                    if (tmp13_subject instanceof ProductDetails) {
                                      tmp_0 = '/product/' + toString(this.h14y_1.u108_1.nzt_1);
                                    } else {
                                      if (tmp13_subject instanceof BeadsProductDetails) {
                                        tmp_0 = '/product/' + toString(this.h14y_1.i109_1.nzt_1);
                                      } else {
                                        if (tmp13_subject instanceof CustomMugDetails) {
                                          tmp_0 = '/product/' + toString(this.h14y_1.x109_1.nzt_1);
                                        } else {
                                          if (tmp13_subject instanceof CustomMagicMugDetails) {
                                            tmp_0 = '/product/' + toString(this.h14y_1.l10a_1.nzt_1);
                                          } else {
                                            if (tmp13_subject instanceof CartNormalProductDetails) {
                                              tmp_0 = '/product/' + toString(this.h14y_1.a10c_1.gyw_1);
                                            } else {
                                              if (tmp13_subject instanceof CartMugProductDetails) {
                                                tmp_0 = '/product/' + toString(this.h14y_1.d10c_1.gyw_1);
                                              } else {
                                                if (tmp13_subject instanceof CartMagicMugProductDetails) {
                                                  tmp_0 = '/product/' + toString(this.h14y_1.g10c_1.gyw_1);
                                                } else {
                                                  if (tmp13_subject instanceof Model3D) {
                                                    tmp_0 = '/product/' + this.h14y_1.n10b_1.toString();
                                                  } else {
                                                    if (tmp13_subject instanceof OrderDetails) {
                                                      tmp_0 = '/order/' + toString(this.h14y_1.m10c_1.lzc_1);
                                                    } else {
                                                      if (tmp13_subject instanceof PastOrderDetails) {
                                                        tmp_0 = '/order/' + toString(this.h14y_1.p10c_1.lzc_1);
                                                      } else {
                                                        tmp_0 = null;
                                                      }
                                                    }
                                                  }
                                                }
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
          var path = tmp_0;
          if (!(path == null) && !(window.location.pathname === path)) {
            window.history.pushState(null, '', path);
          }
          var tmp_1 = title;
          var tmp_2 = window.location.href;
          this.i14y_1.uyi(tmp_1, tmp_2, path == null ? window.location.pathname : path);
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(ComposableSingletons$MainKt$lambda$207007617$lambda$slambda_1).q24 = function ($this$LaunchedEffect, completion) {
    var i = new ComposableSingletons$MainKt$lambda$207007617$lambda$slambda_1(this.g14y_1, this.h14y_1, this.i14y_1, completion);
    i.j14y_1 = $this$LaunchedEffect;
    return i;
  };
  function ComposableSingletons$MainKt$lambda$207007617$lambda$slambda_2($appViewModel, $currentScreen, $analytics, resultContinuation) {
    var i = new ComposableSingletons$MainKt$lambda$207007617$lambda$slambda_1($appViewModel, $currentScreen, $analytics, resultContinuation);
    return constructCallableReference(function ($this$LaunchedEffect, $completion) {
      return i.p24($this$LaunchedEffect, $completion);
    }, 1);
  }
  function ComposableSingletons$MainKt() {
    ComposableSingletons$MainKt_instance = this;
    var tmp = this;
    tmp.k14x_1 = ComposableLambda$invoke$ref(composableLambdaInstance(207007617, false, ComposableSingletons$MainKt$lambda$207007617$lambda));
  }
  var ComposableSingletons$MainKt_instance;
  function ComposableSingletons$MainKt_getInstance() {
    if (ComposableSingletons$MainKt_instance == null)
      new ComposableSingletons$MainKt();
    return ComposableSingletons$MainKt_instance;
  }
  function mainWrapper() {
    main();
  }
  //region block: init
  hadaya_client_web_webapp_generated_resources_Res_drawable$stable = 0;
  hadaya_client_web_webapp_generated_resources_Res_string$stable = 0;
  hadaya_client_web_webapp_generated_resources_Res_array$stable = 0;
  hadaya_client_web_webapp_generated_resources_Res_plurals$stable = 0;
  hadaya_client_web_webapp_generated_resources_Res_font$stable = 0;
  hadaya_client_web_webapp_generated_resources_Res$stable = 0;
  //endregion
  //region block: exports
  kotlin_io_ktor_ktor_client_core.$jsExportAll$(_);
  kotlin_io_coil_kt_coil3_coil_network_ktor3.$jsExportAll$(_);
  kotlin_dev_whyoleg_cryptography_cryptography_provider_webcrypto.$jsExportAll$(_);
  //endregion
  mainWrapper();
  return _;
}));

//# sourceMappingURL=Hadaya_client_web-webApp.js.map
